<style>
  @import '../css/_search-base.css';
</style>
<template>
  <!-- search bar & opts -->
  <div class="search-app space-top-1" :class="parentClass">
    <div class="svg-sprite">
      <svg xmlns="http://www.w3.org/2000/svg">
        <symbol id="i-search" viewBox="0 0 32 32">
          <circle cx="14" cy="14" r="12"/>
          <path d="M23 23l7 7"/>
        </symbol>
        <symbol id="i-close" viewBox="0 0 32 32">
          <path d="M2 30 L30 2 M30 30 L2 2"/>
        </symbol>
        <symbol id="i-checkmark" viewBox="0 0 32 32">
          <path d="M2 20l10 8L30 4"/>
        </symbol>
      </svg>
    </div>
    <div class="row center-xs">
      <div class="search-wrapper col-sm-10 container-fluid">
          <slot name="intro">
            <!-- put a header or intro above the search bar here -->
          </slot>
        <div class="basic-search row center-xs space-top-2" v-if="!isAdvSearch">
          <div class="search-bar col-xs-12 col-sm-10">
            <label for="q" class="sr-only">Search</label>
            <input type="text" class="" v-model="queryObj.q" :placeholder="queryPlaceholder" @keyup.enter="newSearch" id="q">
            <button type="submit" class="btn search-btn" @click.prevent="newSearch">Search</button>
          </div>
        </div>
        <slot name="advanced-search" :queryObj="queryObj">
          <advanced-search v-if="isAdvSearch" :advSearch="advSearch" :queryObj="queryObj"></advanced-search>
        </slot>
        <div class="row center-xs">
          <div class="col-xs-12 col-sm-10">
            <div class="row search-options">
              <div class="col-xs-12 col-sm-9">
                <div class="row space-bottom-1 ">
                  <div class="col-xs-12 col-sm-6">

                    <slot name="search-scope" :queryObj="queryObj" :scope="queryOpts.scope">
                      <label for="search_scope">Any Field</label>
                      <select name="search_scope" id="search_scope" v-model="queryObj.index">
                        <option v-for="opt in queryOpts.scope" :value="opt.value">{{ opt.label }}</option>
                      </select>
		                </slot>

                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-3 adv-search-toggle" :class="{ 'adv-search': isAdvSearch }">
                <button type="submit" class="btn search-btn" @click.prevent="newSearch">Search</button>
                <a type="button" href="" class="text-small" @click.prevent="toggleAdvSearch">{{ advLabel }} search</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- active filters -->
    <div class="row space-top-1  mra-active-filters">
      <div class="col-xs-12">
        <span class="facet-limit-label" v-if="results.length || getActiveFilters().length">{{facetLimitLabel}}</span>
        <button v-for="a in activeFilters" class="btn btn-light filter-term term-selected" @click="toggleFilterAction(a.field, a.term)">
          {{ a.term }}
          <span class="filter-icon">
            <svg class="svg-icon i-checkmark">
              <use xlink:href="#i-checkmark">
            </use>
            </svg>
            <svg class="svg-icon i-close">
              <use xlink:href="#i-close">
            </use>
          </svg>
          </span>
        </button>
        <button class="btn btn-light filter-term" @click="clearFiltersAction()" v-if="activeFilters.length > 1">Clear filters</button>
      </div>
    </div>

    <slot name="show-and-hide-facets"></slot>

    <div class="row"  v-show="showSearchResults">
      <!-- facets -->
      <div id="facets-column" :class="['col-xs-12', 'col-sm-12', 'col-md-3']" v-show="!facetIsCollapsed">
        <div class="facets-wrapper">
          <slot name="facets">
            <filter-component v-for="f in filteredFacetGroups()"
                       :field="f.field"
                       :fg="f"
                       v-show="f.buckets.length > 0"
            > 
          </filter-component>
          </slot>
        </div>
      </div>
      <!-- results -->
      <div id="results-column" :class="['col-xs-12','col-sm-12', facetIsCollapsed ? 'col-md-12' : 'col-md-9']">
        <div class="search-section-top space-top-1">
          <slot name="results-options" :queryOpts="queryOpts" :queryObj="queryObj">
            <span>{{ total }} Results</span>
            <label for="size" class="sr-only">Size</label>
            <select name="size" v-model="queryObj.size" id="size" @change="updateQuery">
              <option v-for="o in sizeOpts" :value="o">Show {{o}}</option>
            </select>
            <label for="sort_by" class="sr-only">Sort by</label>
            <select name="sort_by" id="sort_by" v-model="queryObj.sort" @change="updateQuery">
              <option v-for="opt in queryOpts.sort" :value="opt.value">{{ opt.label }}</option>
            </select>
          </slot>
          <slot name="pagination" :queryObj="queryObj" :total="total">
            <pagination :size="queryObj.size" :from="queryObj.from" :total="total"
                        :currentPage="currentPage"></pagination>
          </slot>
        </div>
        <div class="results">
          <div class="no results">
            <p v-if="!queryObj.q  && !results.length">{{ queryPrompt }}</p>
            <p v-if="queryObj.q && !loading && !total && !searchError">No results found.</p>
            <p v-if="searchError">Sorry, there has been an error. Please try again.</p>
          </div>
          <transition name="slide" :duration="{ enter: 500, leave: 300 }">
            <div v-if="!loading">
              <slot name="results-slot" :results="results">
                <component v-for="r in results" :key="r._id" :is="resultsView" :r="r"></component>
              </slot>
            </div>
          </transition>
          <div class="loading center-txt" v-if="loading">
            loading...
          </div>
        </div>
        <div class="box search-section-bottom space-top-1">
          <pagination :size="queryObj.size" :from="queryObj.from" :total="total" :currentPage="currentPage"></pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, reactive, computed, onMounted, watch, getCurrentInstance, toRaw } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import advancedSearch from './components/_advanced-search.vue'
  import pagination from './components/_pagination.vue'
  import { useFacets } from './composables/useFacets.js'
  import useAdvancedSearch from './composables/useAdvSearch.js'

  const props = defineProps({
    labels: {
      queryPlaceholder: String
    },
  })

  const route = useRoute()
  const router = useRouter()
  const instance = getCurrentInstance()
  const global = instance.appContext.config.globalProperties;

  let queryObj = reactive({
    q: '',
    size: 20,
    from: 0,
    sort: '_score',
    term: '',
    nested_term: '',
    terms: '',
    range: '',
    index: global.$searchOpts.defaultIndex
  })

  const queryOpts = reactive({
    scope: global.$searchOpts.searchScope,
    sort: global.$searchOpts.sortResults
  })

  const queryPrompt = global.$searchOpts.queryPrompt
  const showSearchResults = ref(true)
  const parentClass = ref('')
  const isAdvSearch = ref(false)
  const advSearch = global.$advSearch
  const resultsView = ref('result-list')
  const total = ref('')
  const currentPage = ref(1)
  const sizeOpts = global.$searchOpts.pageSizes
  const results = ref([])
  const loading = ref(false)
  const q = ref('')
  const searchError = ref(false)
  const queryPlaceholder = props?.labels?.queryPlaceholder ? props.labels.queryPlaceholder : "Enter keywords"

  const advLabel = computed(() => (isAdvSearch.value ? 'Basic' : 'Advanced'))

  const facetLimitLabel = global.$searchOpts.facetLimitLabel // todo: put this in props.labels
  const facetIsCollapsed = ref(false)
  const activeFilters = ref([])

  const {
    updateFacets,
    facetGroups,
    toggleFilterAction,
    clearFiltersAction,
    aggsQueryObj,
    getActiveFilters,
    updateFromQueryObj,
    makeTermsStr,
    makeRangeStr,
    filterComponent
  } = useFacets()
  const {
    makeQueryString, advSearchRefs
    } = useAdvancedSearch()
  
  function filteredFacetGroups() {
    const filteredFacetGroups = {}
    for (const f in facetGroups) {
      if (facetGroups[f].type !== 'hidden' && facetGroups[f].buckets?.length > 0) {
        filteredFacetGroups[f] = facetGroups[f]
      }
    }
    return filteredFacetGroups
  }

  onMounted(() => {
    if (Object.keys(route.query).length === 0) {
      showSearchResults.value = false
    }
  })

  const newSearch = () => {
    if (queryObj.q === '') {
      queryObj.q = '*'
    }
    queryObj.from = 0
    updateQuery()
  }

  const toggleAdvSearch = () => {
    isAdvSearch.value = !isAdvSearch.value
    const routerObj = {
      path: '/',
      query: queryObj
    }
    if (isAdvSearch.value) {
      routerObj.path = '/advanced'
    } else {
      q.value = queryObj.q
    }
    router.push(routerObj).catch((err) => {
      console.log(err)
    })
  }

  const updateQuery = () => {
    if (isAdvSearch.value) {
      queryObj.q = makeQueryString()
    }
    router.push({
      query: queryObj
    }).catch((err) => {
      console.log(err)
    })
  }

  const search = async () => {
    loading.value = true
    showSearchResults.value = true
    const aggsObj = aggsQueryObj()
    try {
      const response = await global.$apiSearch.post(window.location.search, aggsObj)
      if (response.error) {
        searchError.value = true
      } else {
        searchError.value = false
      }
      if (response.error || !response.total) {
        loading.value = false
        total.value = 0
        results.value = []
        updateFromQueryObj({})
        updateFacets(response.aggs);
        return
      }
      results.value = response.results
      updateFromQueryObj(response.aggs)
      total.value = response.total
      currentPage.value = Math.ceil((queryObj.size + queryObj.from) / queryObj.size)
      updateFacets(response.aggs);
      loading.value = false
    } catch (err) {
      console.log(err)
      searchError.value = true
    }
  }

  const pageChange = (from) => {
    queryObj.from = from
    updateQuery()
  }

  const filterChange = () => {
    const termsStr = makeTermsStr()
    queryObj.term = termsStr['termStr']
    queryObj.nested_term = termsStr['nestedTermStr']
    queryObj.range = makeRangeStr()
    activeFilters.value = getActiveFilters()
    newSearch()
  }

  const toggleFacet = (collapsed) => {
    if (collapsed) {
      facetIsCollapsed.value = collapsed
    } else {
      facetIsCollapsed.value = !facetIsCollapsed.value
    }
  }

  // Event listeners
  global.$eventBus.on('new-search', newSearch)
  global.$eventBus.on('update-query', updateQuery)
  global.$eventBus.on('filter-change', filterChange)
  global.$eventBus.on('toggle-filter', (ft) => {
    toggleFilterAction(ft.field, ft.term)
    filterChange()
  })
  global.$eventBus.on('page-change', pageChange)
  global.$eventBus.on('toggle-facet', toggleFacet)

  // routes
  if (route.path === '/advanced') {
    isAdvSearch.value = true
  } else {
    isAdvSearch.value = false
  }

  if (route.query.q === '') {
    queryObj.q = '*'
  }


  queryObj = Object.assign(queryObj, parseQueryParams(route.query))
  updateFromQueryObj(queryObj)
  activeFilters.value = getActiveFilters()

  // watch route for changes
  watch(
    () => route.params, () => {
      queryObj = Object.assign(queryObj, parseQueryParams(route.params))
      search()
      },
      {
        immediate: true  // always fire on first load
      }
  )

  function parseQueryParams(query) {
    if (query.from) {
      query.from = parseInt(query.from)
    }
    if (query.size) {
      query.size = parseInt(query.size)
    }
    return query
  }

</script>